<div class="confirmation-modal-container">
  <div class="custom-modal-header">
    <div class="title">{{ title | translate }}</div>
    <div class="close-button" (click)="close()"><i class="bi bi-x x-icon"></i></div>
  </div>
  <div class="custom-modal-content">
    <div [formGroup]="form" class="row form-wrapper">
      <div class="col-12">
        <app-textarea-form-field
          formControlName="resolution"
          [label]="'label.resolution' | translate"
          [placeholder]="'label.resolution_placeholder' | translate"
        ></app-textarea-form-field>
      </div>
    </div>
  </div>
  <div class="custom-modal-footer">
    <div class="submit-actions">
      <button class="btn secondary-button" (click)="confirm(false)">{{ notConfirmActionLabel | translate }}</button>
      <button [disabled]="!form.valid" class="btn primary-button" (click)="confirm(true)">{{ confirmActionLabel | translate }}</button>
    </div>
  </div>
</div>